/* PRDGY stale infinite-scroll neutralizer — old auto loader disabled after manual Load More rollout. */
(function(){
  try {
    document.documentElement.classList.remove('prdgy-infinite-enabled');
    window.__PRDGY_STALE_INFINITE_DISABLED__ = true;
  } catch(e) {}
})();
